const DocMenuConfig = [
    {
        pages: [
            {
                heading: "dashboard",
                route: "/dashboard",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-app-indicator",
            },
            {
                sectionTitle: "customerList",
                route: "/customer",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "customerList",
                        route: "/customer",
                    },
                    {
                        heading: "customerAdd",
                        route: "/customer/save",
                    },
                ]
            },
            {
                sectionTitle: "stockList",
                route: "/stock",
                svgIcon: "/media/icons/duotune/communication/com006.svg",
                fontIcon: "bi-person",
                sub: [
                    {
                        heading: "stockList",
                        route: "/stock",
                    },
                    {
                        heading: "category",
                        route: "/stock/category",
                    },
                    {
                        heading: "warehouse",
                        route: "/stock/warehouse",
                    }
                ]
            },
            {
                sectionTitle: "financialManagement",
                route: "/cash-register",
                svgIcon: "/media/icons/duotune/finance/fin001.svg",
                fontIcon: "bi-cash-stack",
                sub: [
                    {
                        heading: "cashRegister",
                        route: "/cash-register",
                    },
                    {
                        heading: "transaction",
                        route: "/transaction",
                    },
                ]
            },
        ],
    },
    {
        heading: "modules",
        pages: [
            {
                type: "module",
                sectionTitle: "VEHICLE_WORK_ORDER",
                route: "/vehicle-work-order",
                svgIcon: "/media/icons/duotune/art/art002.svg",
                fontIcon: "bi-journals",
                sub: [
                    {
                        heading: "vehicleWorkOrder",
                        route: "/module/vehicle-work-order/",
                    },
                    {
                        heading: "vehicleWorkOrderAdd",
                        route: "/module/vehicle-work-order/save",
                    },
                    {
                        heading: "vehicleWorkOrderList",
                        route: "/module/vehicle-work-order/list",
                    },
                    {
                        heading: "vehicleWorkOrderOpen",
                        route: "/module/vehicle-work-order/list/1",
                    },
                    {
                        heading: "vehicleWorkOrderOngoing",
                        route: "/module/vehicle-work-order/list/2",
                    },
                    {
                        heading: "vehicleWorkOrderCompleted",
                        route: "/module/vehicle-work-order/list/3",
                    },
                ]
            },
            {
                type: "module",
                heading: "NOTE",
                action: "panel:noteApp",
                svgIcon: "/media/icons/duotune/files/fil024.svg",
                fontIcon: "bi-journal-text",
            },
            {
                type: "module",
                heading: "AGENDA",
                action: "panel:agendaPanel",
                svgIcon: "/media/icons/duotune/general/gen014.svg",
                fontIcon: "bi-calendar-event",
            },
            {
                heading: "allModules",
                route: "/module",
                svgIcon: "/media/icons/duotune/abstract/abs027.svg",
                fontIcon: "bi-layers",
            },
        ],
    },
];

export default DocMenuConfig;
